import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46800d41")

_pushScopeId("data-v-46800d41")
const _hoisted_1 = { class: "header-entity" }
const _hoisted_2 = {
  key: 0,
  style: {"padding-inline-start":"10px","opacity":"0.8"}
}
const _hoisted_3 = { style: {"font-weight":"600"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = { class: "cancel-receipt-link" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: _ctx.isNew ? 'header-entity-name-new' : 'header-entity-name'
    }, [
      _createVNode("div", null, [
        (_ctx.showLeftToPay)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('label.left-to-pay')) + " ", 1),
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.formatAmount(_ctx.leftToPay)), 1),
              _hoisted_4,
              _createVNode("span", null, _toDisplayString(_ctx.currencySign), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("h1", {
        class: ["cuted-cell-one-line", _ctx.titleClass]
      }, _toDisplayString(_ctx.name), 3),
      _createVNode("div", {
        class: [{ hideActionsOnMobile: _ctx.hideActionsOnMobile }, "header-entity-actions"]
      }, [
        _createVNode("button", {
          class: "header-entity-actions-cancel",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, _toDisplayString(_ctx.isNew ? _ctx.$t('button.cancel') : _ctx.$t('button.back')), 1),
        (_ctx.showViewPdf)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "header-entity-actions-edit",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.viewPdfDocument && _ctx.viewPdfDocument(...args)))
            }, _toDisplayString(_ctx.$t('button.view-pdf')), 1))
          : _createCommentVNode("", true),
        (_ctx.showShare)
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              class: "header-entity-actions-edit",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shareDocument && _ctx.shareDocument(...args)))
            }, _toDisplayString(_ctx.$t('documents.share')), 1))
          : _createCommentVNode("", true),
        (!_ctx.hideEdit)
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              (_ctx.editMode || _ctx.isNew)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "header-entity-actions-save",
                    type: "submit",
                    form: _ctx.form
                  }, _toDisplayString(_ctx.$t('button.save')), 9, ["form"]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "header-entity-actions-edit",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.edit()))
                  }, _toDisplayString(_ctx.$t('button.edit')), 1))
            ], 64))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("a", {
            class: "text-link",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelDocument()))
          }, _toDisplayString(_ctx.cancelButtonText), 513), [
            [_vShow, _ctx.showCancelDocument]
          ])
        ])
      ], 2)
    ], 2)
  ]))
})